import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { bankAccountsApi } from './api'
import type { CreateBankAccountPayload } from './types'

export function useBankAccounts() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'bankAccounts'),
    queryFn: bankAccountsApi.list,
    staleTime: 0,
    refetchOnMount: 'always',
  })
}

export function useRecentBanks() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'bankAccounts', 'recent-banks'),
    queryFn: bankAccountsApi.recentBanks,
    staleTime: 60_000,
  })
}

export function useCreateBankAccount() {
  const tenantId = useTenant()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: CreateBankAccountPayload) => bankAccountsApi.create(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'bankAccounts') })
    },
  })
}
